<template>
  <div class="nw">
    <el-card v-if="post.origin_weibo">
      <div class="wbinfo">
        <div>
          <p class="username">{{post.userName}}</p>
          <time>{{post.create_time}}</time>
          <a class="orilink" target="_blank" :href="post.weibo_url">原始链接</a>
        </div>
        <el-button
          class="favorite"
          type="text"
          v-show="post.favorite"
          @click="favorite(post.weiboID)"
        >
          <p v-html="collect(post.favorite)" style="margin:4px 0"></p>
        </el-button>
        <el-button
          class="notfavorite"
          type="text"
          v-show="!post.favorite"
          @click="favorite(post.weiboID)"
        >
          <p v-html="collect(post.favorite)" style="margin:4px 0"></p>
        </el-button>
      </div>
      <p class="wbcontent" v-html="decorating(post.weibo_cont,post.links)"></p>
      <div class="expand">
        <p class="username">{{post.origin_weibo.userName}}</p>
        <time>{{post.origin_weibo.create_time}}</time>
        <a class="orilink" target="_blank" :href="post.origin_weibo.weibo_url">原始链接</a>

        <p
          class="wbcontent"
          v-html="decorating(post.origin_weibo.weibo_cont,post.origin_weibo.links)"
        ></p>
        <!-- <el-carousel
          :interval="4000"
          type="card"
          height="200px"
          v-if="post.origin_weibo.images.length>0"
        >-->
        <div v-if="post.origin_weibo.images.length>0" class="imgbox">
          <img v-for="(image,i) in post.origin_weibo.images" :key="i" :src="image" class="imgitem">
          <!-- <el-carousel-item v-for="(image,i) in post.origin_weibo.images" :key="i">
            <img :src="image">
          </el-carousel-item>
          </el-carousel>-->
        </div>
      </div>
    </el-card>
    <el-card v-else>
      <div class="wbinfo">
        <div>
          <p class="username">{{post.userName}}</p>
          <time>{{post.create_time}}</time>
          <a class="orilink" target="_blank" :href="post.weibo_url">原始链接</a>
        </div>
        <el-button
          class="favorite"
          type="text"
          v-show="post.favorite"
          @click="favorite(post.weiboID)"
        >
          <p v-html="collect(post.favorite)" style="margin:4px 0"></p>
        </el-button>
        <el-button
          class="notfavorite"
          type="text"
          v-show="!post.favorite"
          @click="favorite(post.weiboID)"
        >
          <p v-html="collect(post.favorite)" style="margin:4px 0"></p>
        </el-button>
      </div>
      <p class="wbcontent" v-html="decorating(post.weibo_cont,post.links)"></p>
      <div v-if="post.images.length>0" class="imgbox">
        <img v-for="(image,i) in post.images" :key="i" :src="image" class="imgitem">
      </div>
      <!-- <el-carousel :interval="4000" type="card" height="200px" v-if="post.images.length>0">
        <el-carousel-item v-for="(image,i) in post.images" :key="i">
          <img :src="image">
        </el-carousel-item>
      </el-carousel>-->
    </el-card>
  </div>
</template>

<script>
export default {
  name: "normalweibo",
  props: ["post"],
  methods: {
    decorating: function(content, links) {
      //[链接:O网页链接]
      //[链接:#Bilibili#]
      //[链接:#bilibili#]
      //[换行:br]
      content = content.replace(/\[换行:br\]/g, "<br/>");
      //链接替换
      if (links.length > 0) {
        var reg1 = /\[\u94fe\u63a5:.*?\]/g;
        //var reg2 = /(?<=\[\u94fe\u63a5:).*?(?=\])/g;
        var m2 = content.match(reg1);
        var m1 = [];
        if (m2)
          for (let index = 0; index < m2.length; index++) {
            const element = m2[index];
            m1[index] = element.substring(4, element.length - 1);
          }
        // var m1 = content.match(reg2);
        var len = 0;
        //处理特殊符号，链接
        var res = content.replace(reg1, function() {
          var testch = /^[a-zA-z0-9\ue627\u00b0\u00a1]/;
          if (testch.test(m1[len])) {
            m1[len] = m1[len].replace(testch, function() {
              return '<i class="W_ficon">' + arguments[0] + "</i>";
            });
          }
          return (
            '<a class="link" target="_blank" href=' +
            links[len] +
            ">" +
            m1[len++] +
            "</a>"
          );
        });
        //处理表情
        //TODO
        var facereg = /\[\u8868\u60c5:\[.*?\]\]/g;
        if (facereg.test(res)) {
          res = res.replace(facereg, function() {
            return (
              '<img class="img_face" title="' +
              arguments[0].substring(4, arguments[0].length - 1) +
              '" src=' +
              links[len++] +
              " />"
            );
          });
        }
        return res;
      } else {
        return content;
      }
    },
    collect: function(content) {
      if (content == false) {
        return '<i class="W_ficon star">û</i>收藏';
      }
      return '<i class="W_ficon star">û</i>已收藏';
    },
    favorite: function(weiboid) {
      this.$emit("homefavorite");
    }
  }
};
</script>
<style>
.expand {
  background-color: #f3f3f3;
  margin: 0 -20px -20px -20px;
  padding: 10px 20px 20px 20px;
}
.imgbox {
  display: flex;
  flex-wrap: wrap;
  /* width: 320px; */
}
.imgitem {
  /* max-width: 30%; */
  max-height: 100px;
  margin: 2px;
}
.nw {
  break-inside: avoid;
  box-sizing: border-box;
  padding: 5px;
  min-width: 330px;
}
.username {
  margin-top: 0%;
  margin-bottom: 0%;
  font-size: 14px;
  font-weight: 700;
}
.orilink,
time {
  color: rgb(100, 100, 100);
  text-decoration: none;
  font-size: 12px;
}
.wbcontent {
  font-size: 15px;
  margin: 10px 0;
}
.el-card__body {
  padding-top: 10px !important;
}
.link {
  color: #eb7350;
  text-decoration-line: none;
}
.W_ficon {
  font-family: "wbicon" !important;
  font-style: normal;
  margin: 0 1px 0 4px;
}
img {
  transform: scale(1); /*图片原始大小1倍*/
  transition: all ease 0.5s;
} /*图片放大所用时间*/
.img_face {
  width: 18px;
  height: 18px;
  vertical-align: -4px;
}
img.active {
  transform: scale(3); /*图片需要放大3倍*/
  position: absolute; /*是相对于前面的容器定位的，此处要放大的图片，不能使用position：relative；以及float，否则会导致z-index无效*/
  z-index: 100;
}
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
.favorite,
.notfavorite {
  font-size: 13px !important;
  padding: 0 !important;
  float: right;
}
.favorite {
  color: #eb7350 !important;
}
.notfavorite {
  color: rgb(100, 100, 100) !important;
}

.star {
  margin: 0 4px;
}
.wbinfo {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/weiboitem/NormalWeibo.vue